import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, IConsentLetters, ISurgicalData } from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchFaceLift,
  fetchFaceLiftBanner,
} from "../../api/SurgicalDomainApi";

const FaceLift = () => {
  const { setLoading } = useLoader();
  const [faceLiftBanner, setFaceLiftBanner] = useState<IBannerData[]>([]);
  const [faceLiftData, setFaceLiftData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([fetchFaceLiftBanner(), fetchFaceLift(), fetchConsentLetters()])
      .then(([faceLiftBannerData, faceLiftData, consentLettersData]) => {
        setFaceLiftBanner(faceLiftBannerData);
        setFaceLiftData(faceLiftData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner bannerData={faceLiftBanner} page={"Face Lift"} />
      <SurgicalDomainsDescription descriptionData={faceLiftData} consentLetters={consentLetters} surgicalName='Face_Lift'/>
    </>
  );
};

export default FaceLift;
